import { Navigate } from 'react-router-dom';
import { isExpired } from "react-jwt";

const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('Token_Kinto_Admin');

    return !isExpired(token) ? children : <Navigate to="/login" />;
};

export default PrivateRoute;